// Path: /home/jason/src/AgileView/autovision-ui/src/components/ButtonDeployModel.tsx

import React, { useState } from 'react'
import { Button } from 'react-bootstrap'
import { Model } from '../types/models/model'
import { useDeleteModelDeploymentMutation, useDeployModelMutation } from '../services/modelsApi'
import { Rocket, Trash2 } from 'lucide-react'
import './ButtonDeployModel.css'
import ConfirmDialog from './modals/ConfirmDialog'
import ErrorDialog from './modals/ErrorDialog'

interface ButtonDeployModelProps {
  model: Model
}

const ButtonDeployModel: React.FC<ButtonDeployModelProps> = ({ model }) => {
  const [deployModel] = useDeployModelMutation()
  const [deleteDeployment] = useDeleteModelDeploymentMutation()
  const [showDeleteDeploymentConfirm, setShowDeleteDeploymentConfirm] = useState(false)
  const [error, setError] = useState<string | null>(null)
  const [showError, setShowError] = useState(false)

  const handleDeploy = async (e: React.MouseEvent<HTMLButtonElement>) => {
    e.stopPropagation()
    try {
      await deployModel({ id: model.id }).unwrap()
    } catch (error) {
      setError(error ? (error as any).data.message : 'An unexpected error occurred')
      setShowError(true)
    }
  }

  const handleDeleteDeploy = async () => {
    try {
      await deleteDeployment({ id: model.id }).unwrap()
    } catch (error) {
      setError(error ? (error as any).data.message : 'An unexpected error occurred')
      setShowError(true)
    }
  }

  if (showDeleteDeploymentConfirm) {
    return (
      <ConfirmDialog
        show={showDeleteDeploymentConfirm}
        onHide={() => setShowDeleteDeploymentConfirm(false)}
        onConfirmRight={() => {
          handleDeleteDeploy()
        }}
        title="Remove Endpoint"
        message={
          'You are about to remove this endpoint.  The model will still be available for re-deployment'
        }
        confirmRightText="Remove Endpoint"
        cancelText="Cancel"
        variant="danger"
      />
    )
  }

  if (showError) {
    return <ErrorDialog show={showError} onHide={() => setShowError(false)} message={error} />
  }

  if (model.state?.toLowerCase() !== 'trained') {
    return <div className="button-placeholder" />
  }

  if (model.deployment?.status?.toLowerCase() === 'in_service') {
    return (
      <Button
        className="custom-button delete-button"
        onClick={(e) => {
          e.stopPropagation()
          setShowDeleteDeploymentConfirm(true)
        }}
      >
        <Trash2 className="me-2" size={16} />
        Remove Endpoint
      </Button>
    )
  }

  if (model.deployment?.status?.toLowerCase() === 'creating') {
    return (
      <Button
        className="custom-button deploy-button deploying"
        onClick={(e) => {
          e.stopPropagation()
          setShowDeleteDeploymentConfirm(true)
        }}
      >
        <Rocket className="me-2" size={16} />
        Deploying...
      </Button>
    )
  }

  return (
    <Button className="custom-button deploy-button" onClick={handleDeploy}>
      <Rocket className="me-2" size={16} />
      Deploy Model
    </Button>
  )
}

export default ButtonDeployModel
